<style scoped>
.horizontal-scrolling-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}
.horizontal-scrolling-wrapper .card {
  flex: 0 0 auto;margin-right:5px;
}
.scrolling-wrapper {
  -webkit-overflow-scrolling: touch;
}

@media only screen and (max-width: 1441px) {
  .calendar-container {
      padding: 0px !important;
      margin-top: 1px;
      max-width: 100%;
  }
}

.week .day {
  background-color: white;
  padding: 10px;
  width:50px;
  text-align:center;
}
.week .day.visible {
  border-bottom: solid 2px lightblue;
}
.week .day.active {
  border: solid 1px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-background-clip: padding-box;
  -moz-background-clip:    padding;
  background-clip:         padding-box;
  /* border-bottom: solid 2px blue; */
}
.weekviewactive {
  background-color: #fefee1;
  border-left: solid 1px yellow;
  border-right: solid 1px yellow;
}
.weekviewactive .v-subheader {
  color:black;
  font-weight:bold;
}
.week .day .dow.dow-mon {
  font-weight: bold;color:#666;
}

.week .day .date{
  font-size: larger;
}
.week .day.today .date{
  background:red;
  border-radius: 50%;
  width:25px;
  height:25px;color:#f1f1f1;
}
.fullscreen {
  position:absolute;
  top:0px;
  left:5px;
  right:5px;
  bottom:0px;
  z-index:12;
  margin-top:-55px;
}
</style>
<template>
<v-layout class="calendar" >
    <!-- <request-status :request='appointmentsRequest' :message200='false' /> -->
    <v-dialog v-model="settingsDialog" persistent fullscreen >
      <v-card>
        <v-card-title>
            <v-subheader>Settings</v-subheader>
            <v-spacer></v-spacer>
            <v-btn @click='settingsDialog=false' icon><v-icon>close</v-icon></v-btn>
        </v-card-title>
      </v-card>
    </v-dialog>

    <!-- <v-btn @click.native.stop='bottomsheet=!bottomsheet' >{{bottomsheet}}</v-btn> -->

  <v-container class='calendar-container' fluid >
    <!-- <v-btn @click='testAddAppt' >Add appt</v-btn>
    <v-btn @click='testRemove' >Remove appt</v-btn> -->
    <!-- <pre>{{events}}</pre> -->
    <v-card>
      <request-status :request='appointmentsRequest' :message200='false' />
      <v-system-bar flat dark >
        <v-icon @click='refresh' >replay</v-icon>
        <!-- {{watchString}} -->
        <!-- <span v-if='practitioner' class='ml-2 overline' >{{practitioner.full_name}}</span> -->
        <v-btn @click='doShowCalendar(true, "date")' flat text >{{naturalday(selectedDate)}}</v-btn>
        <v-spacer></v-spacer>

        <calendar-settings v-model='settings' ></calendar-settings>
        <v-btn @click='doShowCalendar(true, "date")' icon ><v-icon>event</v-icon></v-btn>
        <v-dialog v-model='showCalendar' width='350' >
          <v-card flat>
            <v-date-picker class='elevation-0'
              v-model='selectedDate'
              :type='datePickerType'
              full-width >
            </v-date-picker>
            <v-card-actions >
              <v-btn @click='doShowCalendar(false)' small flat text >Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <span class='overline' @click='gotoToday' >Today is {{ dateformat(now, 'ddd D MMM YY') }}</span>
      </v-system-bar>
      <calendar-tabs dark
        v-if='infoTeamCount > 1'
        v-model='practitioner'
        :facets='facets'
        @space='setSelectedSpace' >
      </calendar-tabs>

      <!-- <v-toolbar class="white" light dense flat >
        <v-btn @click='dateMath(-1, "days")' icon><v-icon>chevron_left</v-icon></v-btn>
        <v-btn @click='doShowCalendar(true, "date")' flat text >{{naturalday(selectedDate)}}</v-btn>
        <v-spacer></v-spacer>
        <calendar-settings v-model='settings' ></calendar-settings>
        <v-btn @click='doShowCalendar(true, "date")' icon ><v-icon>event</v-icon></v-btn>
        <v-dialog v-model='showCalendar' width='350' >
          <v-card flat>
            <v-date-picker class='elevation-0'
              v-model='selectedDate'
              :type='datePickerType'
              full-width >
            </v-date-picker>
            <v-card-actions >
              <v-btn @click='doShowCalendar(false)' small flat text >Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn @click='dateMath(1, "days")' icon><v-icon>chevron_right</v-icon></v-btn>

      </v-toolbar> -->
      <v-divider></v-divider>
      <v-card flat class='solid py-1 hidden-xs-only' >
        <div id='week-view' class='horizontal-scrolling-wrapper week' >
          <div
            v-for='day in monthDates' :key='day'
            @click='selectedDate=day'
            :class="{ 'blue lighten-2': isActive(day), 'yellow lighten-5': isToday(day), 'blue lighten-4 black--text': isVisible(day), 'grey--text': !isVisible(day) }"
            class='day' >
            <div
              :class='"dow-" + dateformat(day,"ddd").toLowerCase()'
              class='dow overline'>{{dateformat(day,'ddd')}}</div>
            <div class='date black--text'>{{dateformat(day,'D')}}</div>
            <!-- <small v-if='isToday(day)' class='overline' >Today</small> -->
          </div>
          <!-- <div class='day' >
            <v-btn @click='changeMonth(1)' flat small >
              {{dateformat(nextMonth, 'MMM')}}
              <v-icon>chevron_right</v-icon>
            </v-btn>
          </div> -->
        </div>
      </v-card>
        <v-layout
          v-touch="{left: () => { dateMath(1, 'days') }, right: () => { dateMath(-1, 'days') }}"
          class='px-1'
          row >
          <v-flex xs12 sm3
            v-for='day in daysToShow' :key='day'
            :class="{weekviewactive: isActive(day)}"
            class='pa-0' >
            <v-subheader
              class='hidden-xs-only overline pl-1 grey lighten-4 justify-center'
              :class="{'grey lighten-2': isActive(day), 'grey lighten-4': !isActive(day)}"
              style='height:24px;border-right:solid 1px #DDD;' >
              {{dateformat(day, 'ddd D MMM') }}
            </v-subheader>

            <practitioner-day-view
              v-if='practitioner'
              :practitioner='practitioner'
              :class="{'elevation-5': isActive(day)}"
              style='border-right:solid 1px #ccc;'
              :with-fetch='false'
              :withWeek='$vuetify.breakpoint.xs'
              :withAdd='$vuetify.breakpoint.xs'
              @dayview:createevent='slotSelected'
              @dayview:delete='deleteEvent'
              @dayview:save='showQuickCreate'
              @dayview:eventclicked='eventClicked'
              @dayview:multiselect='setMultiSelect'
              @update:date='setDate'
              @facets='setFacets'
              :settings="settings"
              :date='day' />
            <!-- <day-view
              :read-only='!isMyCalendar'
              class='elevation-4'
              @dayview:createevent='slotSelected'
              @dayview:delete='deleteEvent'
              @dayview:save='showQuickCreate'
              @dayview:eventclicked='eventClicked'
              @dayview:multiselect='setMultiSelect'
              @facets='setFacets'
              :pixelToMinuteRatio="settings.density"
              :date='day'
              :events='events' ></day-view> -->
          </v-flex>
        </v-layout>

    </v-card>
  </v-container>
</v-layout>
</template>

<script>
import Vue from 'vue'
// import DayView from '@/components/calendar/DayView'
import PractitionerDayView from '@/components/calendar/PractitionerDayView'
import CalendarSettings from '@/components/calendar/CalendarSettings'
import CalendarMixins from '@/components/calendar/CalendarMixins'
import CalendarTabs from '@/components/pickers/CalendarTabs'
import moment from 'moment'
import RequestsMixin from '@/mixins/requests'
import {mapGetters} from 'vuex'
import {
  SET_ACTIVE_DATE_RANGE,
  LIST_APPOINTMENTS_IN_RANGE_REQ,
  SET_SETTING
} from '@/store/constants'

export default {
  name: 'CalendarPage',
  components: {
    // DayView,
    PractitionerDayView,
    CalendarSettings,
    CalendarTabs
  },
  mixins: [RequestsMixin, CalendarMixins],
  data () {
    return {
      reqId: Math.random().toString().split('.')[1],
      selectedDate: moment().format('YYYY-MM-DD'),
      selectedEvent: {},
      selectedEvents: {},
      practitioner: null,
      dayWidth: 40,
      settings: {
        density: 1,
        numDays: null
      },
      facets: {
        spaces: {},
        products: {}
      },
      selectedSpace: null,
      bottomsheet: false,
      settingsDialog: false,
      showCalendar: false,
      datePickerType: 'date',
      nonPersistedEvents: [],
      requests: [
        LIST_APPOINTMENTS_IN_RANGE_REQ
      ],
      flatpickerDateOptions: {
        inline: true,
        altInput: true,
        altFormat: 'D j M'
      },
      calendars: []
    }
  },
  // created () {
  //   this.refresh(true)
  // },
  mounted () {
    if (window.localStorage && window.localStorage.getItem('ag.calendar.settings')) {
      let settings = JSON.parse(window.localStorage.getItem('ag.calendar.settings'))
      this.settings = settings
    }
    if (!this.practitioner) {
      this.practitioner = this.me
    }
    this.refresh()
  },
  watch: {
    appointmentsRequestStatus () {
      if (this.saveAppointmentRequestStatus === 200) {
        this.refreshing = false
      }
    },
    saveAppointmentRequestStatus () {
      // console.log(this.saveAppointmentRequestStatus)
      if (this.saveAppointmentRequestStatus === 201) {
        this.quickCreateDialog = false
      }
    },
    globalActiveDate () {
      if (this.globalActiveDate) {
        // console.log('global date', this.globalActiveDate)
        this.selectedDate = this.globalActiveDate
      }
    },
    globalCalendarDate () {
      if (this.globalCalendarDate) {
        this.selectedDate = this.globalCalendarDate
      }
    },
    watchString () {
      this.refresh()
    },
    // visibleDates () {
    //   if (this.visibleDates.length === 2) {
    //     this.refresh()
    //   }
    // },
    // route () {
    //   if (this.route === 'calendar') {
    //     this.refresh()
    //   } else {
    //     console.log(this.route)
    //   }
    // },
    selectedDate () {
      this.showCalendar = false
      // maybe use moment().isBetween?
      let startDate = this.monthDates[0]
      if (moment(startDate)
            .isAfter(moment(this.daysToShow[0]))) {
        startDate = this.daysToShow[0]
      }

      let endDate = this.monthDates[this.monthDates.length - 1]
      let lastDayToShow = this.daysToShow[this.daysToShow.length - 1]
      if (moment(endDate)
            .isBefore(moment(lastDayToShow))) {
        endDate = lastDayToShow
      }
      endDate = moment(endDate).add(1, 'days').format('YYYY-MM-DD')
      let afterUTC = this.getObjectPath(this.appointmentsRequest, 'params.after_utc')
      let beforeUTC = this.getObjectPath(this.appointmentsRequest, 'params.before_utc')

      let rangeParamsAreDifferent = (
        afterUTC !== startDate ||
        beforeUTC !== endDate
      )
      if (this.appointmentsRequest &&
          this.appointmentsRequest.params &&
          rangeParamsAreDifferent) {
        // console.log('active daterange', startDate, endDate)
        // this.setGlobalActiveDateRange(startDate, endDate)
      }

      // set the scrolling:
      let dayLeft = (moment(this.selectedDate).date() + 1) * this.dayWidth
      let el = document.getElementById('week-view')
      el.scrollLeft = dayLeft - (el.clientWidth / 2)

      /* if (this.selectedDate) {
        let m = moment(this.selectedDate)
        let globalStart = moment(this.globalActiveDateRange.from)
        let globalEnd = moment(this.globalActiveDateRange.to)
        if (m.isBefore(globalStart)) {
          this.setGlobalActiveDateRange(this.selectedDate, this.globalActiveDateRange.to)
        }
        if (m.isAfter(globalEnd)) {
          this.setGlobalActiveDateRange(this.globalActiveDateRange.from, this.selectedDate)
        }
      } */
    }
    // '$route': 'refresh'
  },
  computed: {
    ...mapGetters(['globalCalendarDate']),
    now () {
      return moment()
    },
    watchString () {
      let practitionerId = this.getObjectPath(this, 'practitioner.id')
      return `${practitionerId}-${this.visibleDates}`
    },
    isMyCalendar () {
      if (this.practitioner && this.practitioner.id && this.practitioner.id === this.me.id) {
        return true
      } else {
        return false
      }
    },
    nextMonth () {
      return moment(this.selectedDate).add(1, 'months')
    },
    lastMonth () {
      return moment(this.selectedDate).subtract(1, 'months')
    },
    globalActiveDate () {
      if (this.$store.getters.settings) {
        return this.$store.getters.settings.activeDate
      }
    },
    visibleDates () {
      if (this.daysToShow) {
        return [this.daysToShow[0], this.daysToShow[this.daysToShow.length - 1]]
      }
      return []
    },
    route () {
      return this.$route.path
    },
    appointmentsRequest () {
      return this.$store.getters
        .getRequestById(LIST_APPOINTMENTS_IN_RANGE_REQ)
    },
    appointmentsRequestStatus () {
      return this.appointmentsRequest.status
    },
    saveAppointmentRequest () {
      return this.$store.getters
        .getRequestById(this.reqId, true)
    },
    saveAppointmentRequestStatus () {
      return this.saveAppointmentRequest.status
    },
    daysToShow () {
      if (this.$vuetify.breakpoint.xs) { return [this.selectedDate] }
      let yesterday = moment(moment(this.selectedDate).subtract(1, 'days'))
      let numDays = 5
      if (this.$vuetify.breakpoint.lgAndUp) { numDays = 7 }

      if (this.settings.numDays) {
        numDays = this.settings.numDays
      }
      let days = []
      for (let x = 0; x < numDays; x++) {
        days.push(moment(yesterday).add(x, 'days').format('YYYY-MM-DD'))
      }
      return days
    },
    monthDates () {
      let days = []
      let dt = moment(this.selectedDate)
      let monthEnd = moment(dt.endOf('month'))

      let currentDate = moment(dt.startOf('month'))
      while (currentDate.isSameOrBefore(monthEnd)) {
        let day = currentDate.format('YYYY-MM-DD')
        days.push(day)
        currentDate = moment(currentDate).add(1, 'days')
      }
      return days
    }
  },
  methods: {
    doShowCalendar (visible = true, type = 'date') {
      this.showCalendar = visible
      this.datePickerType = type
    },
    setDate (dt) {
      this.selectedDate = dt
      console.log(this.selectedDate, dt)
    },
    setFacets (facets) {
      this.facets = facets
    },
    setSelectedSpace (spaceId) {
      this.selectedSpace = spaceId
    },
    setMultiSelect (event) {
      if (event && event.id) {
        let selected = true
        if (event.selected === true) { selected = false }
        Vue.set(event, 'selected', selected)
        if (event.id in this.selectedEvents) {
          delete this.selectedEvents[event.id]
        } else {
          this.selectedEvents[event.id] = event
        }
      }
    },
    slotSelected (event) {
      let vm = this
      if (!this.practitioner) {
        this.practitioner = this.me
      }
      setTimeout(() => {
        vm.$store.commit(SET_SETTING, ['startTime', event.start_time])
        vm.$store.commit(SET_SETTING, ['activePractitioner', this.practitioner])
      }, 1000)
      this.openGlobalDialog(true, 'QuickCreate')
    },
    timeStringToMoment (timeString) {
      if (!timeString) {
        console.warn('string passed to timeStringToMoment is null')
        return moment()
      }
      if (timeString.length === 4) {
        timeString = '0' + timeString
      }
      let dt = this.selectedDate
      if (!this.selectedDate) {
        dt = moment().format('YYYY-MM-DD')
      }
      let dateString = `${dt} ${timeString}`
      return moment(dateString)
    },
    changeMonth (count) {
      let dt = null
      if (count > 0) {
        console.log('add')
        dt = moment(this.selectedDate).add(count, 'months')
      } else {
        let positive = count * -1
        dt = moment(this.selectedDate).subtract(positive, 'months')
      }
      this.selectedDate = dt.startOf('month').format('YYYY-MM-DD')
      let end = dt.endOf('month')
      this.$store.commit(SET_ACTIVE_DATE_RANGE, [this.selectedDate, end])
    },
    gotoToday () {
      this.selectedDate = moment().format('YYYY-MM-DD')
    },
    dateMath (change, period) {
      if (change > 0) {
        this.selectedDate = moment(this.selectedDate)
          .add(change, period)
          .format('YYYY-MM-DD')
        let el = document.getElementById('week-view')
        el.scrollLeft = el.scrollLeft + this.dayWidth
      }
      if (change < 0) {
        change = change * -1
        this.selectedDate = moment(this.selectedDate)
          .subtract(change, period)
          .format('YYYY-MM-DD')
        let el = document.getElementById('week-view')
        el.scrollLeft = el.scrollLeft - this.dayWidth
      }
    },
    isToday (day) {
      return (day === moment().format('YYYY-MM-DD'))
    },
    isActive (day) {
      return (day === this.selectedDate)
    },
    isVisible (day) {
      return this.daysToShow.indexOf(day) !== -1
    },
    appointmentCount (day) {
      return this.$store.getters.activeAppointments.filter((item) => {
        let appDay = moment(item.start_time).format('YYYY-MM-DD')
        if (item.status === 'B') { return false }
        return appDay === day.format('YYYY-MM-DD')
      }).length
    },
    showQuickCreate (event) {
      this.selectedEvent = event
      this.quickCreateDialog = true
    },
    deleteEvent (event) {
      // first find it it's in non persisted:
      this.nonPersistedEvents = this.nonPersistedEvents.filter((evt) => {
        return (evt.id !== event.id)
      })
    },
    eventClicked (event) {
      this.bottomsheet = true
      // if (event) {
      //   Vue.set(event, 'selected', true)
      // }
    },
    refresh (initial) {
      if (initial === true) { return false }
      let start = moment(this.daysToShow[0]).format('YYYY-MM-DD')
      let end = moment(this.daysToShow[this.daysToShow.length - 1]).format('YYYY-MM-DD')
      if (!end) {
        end = moment(this.monthDates[this.monthDates.length - 1])
      }
      // let end = moment.max(
      //   moment(this.daysToShow[this.daysToShow.length - 1]),
      //   moment(this.monthDates[this.monthDates.length - 1])
      // ).format('YYYY-MM-DD')
      this.setGlobalActiveDateRange(start, end)

      // this.getAppointmentsInRange(params)
      this.getPractitionerCalendar()

      // if (!this.isMyCalendar) {
      //   this.getPractitionerCalendar()
      // }
    },
    testRemove () {
      this.$store.commit('removeAppointment', 169789)
    },
    testAddAppt () {
      let appt = {
        'id': 169789,
        'start_time': '2021-06-05T10:00:00Z',
        'tags': null,
        'end_time': '2021-06-05T10:50:00Z',
        'title': 'Test event',
        'full_name': 'Test event',
        'client': 44385,
        'practitioner_name': 'Sarah Smith',
        'practitioner': 412,
        'space': 271,
        'service_name': 'Eatwell Dieticians',
        'space_color': 'purple',
        'product': 506,
        'product_name': 'Consultation',
        'product_color': 'green',
        'address_name': 'Eatwell Dieticians, Pretoria',
        'is_recurring': true,
        'status': 'N',
        'status_formatted': 'New',
        'currency': 'ZAR',
        'price': '368.20',
        'notes': null,
        'is_online': false,
        'invoice_description': 'Treated by: Sarah Smith (DT12345678) at Eatwell Dieticians',
        'invoice_title': null,
        'invoiceable': false,
        'done': false,
        'dt': '2021-06-05',
        'start': '12:00',
        'end': '12:50',
        'duration': 50
      }
      this.$store.commit('addAppointments', [appt])
    }
  }
}
</script>



// WEBPACK FOOTER //
// Calendar.vue?1ec464e2